import React, { useState } from 'react';
import ButtonGroup from '@mui/material/ButtonGroup';
import { indexMap } from '@cd/utils';

const ButtonGroupCD = ({ children, defaultIndex, ...props }) => {
	const [index, setIndex] = useState(defaultIndex);
	const onClick = index => e => setIndex(index);
	return (
		<ButtonGroup {...props}>
			{indexMap(
				(child, i) =>
					React.cloneElement(child, {
						onClick: e => {
							onClick(i)(e);
							child.props.onClick();
						},
						variant: i !== index ? 'outlined' : 'contained'
					}),
				children
			)}
		</ButtonGroup>
	);
};

export default ButtonGroupCD;
